<div class="container p-4">
    <div class="container-fluid p-4 text-center card ">
        <h5>Congratulations</h5>
        <img src="assets/email-verified.png" style="max-width: 250px"><br>
        <h6>Your have activated your discount code. Go back to continue shopping and enjoy your discount</h6>
        <div>
        <button class="btn pt-2 pb-2 pl-5 pr-5   mt-4"
                style="background-color: #bb6837 ; color: white ; border-radius: 0px" [routerLink]="'/web/home'" >Home </button>
        </div>

    </div>
</div>
